module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "plm_hd"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Dan_contents"
    }
  }, [_vm._v("CHIEF ABBREVIATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("AB – Anchor Bible")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ABD – ")]), _vm._v("D. N. Freedman et al. (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anchor Bible Dictionary")]), _vm._v(", 6 vols. (New York: Doubleday, 1992)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("AbOTC – Abingdon Old Testament Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ANET – Ancient Near Eastern Texts Relating to the Old Testament")]), _vm._v(", ed. James B. Pritchard, 3rd edn (Princeton: Princeton University Press, 1969)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("AOTC – Apollos Old Testament Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ARAB")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ancient Records of Assyria and Babylonia")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("Daniel David Luckenbill, 2 vols. (Chicago: University of Chicago Press, 1926–1927, repr., New York: Greenwood, 1968)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("AUSS – Andrews University Seminary Studies ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BDB"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" – ")]), _vm._v("Brown, F., S. R. Driver and C. A. Briggs, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Hebrew and English Lexicon of the Old Testament ")]), _vm._v("(Oxford: Clarendon, 1906)"), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BLS – Bible and Literature Series")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ConC – Concordia Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("EANEC – Explorations in Ancient Near Eastern Civilizations ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("EBC – Expositor’s Bible Commentary ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("EvQ – Evangelical Quarterly ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("FOTL – The Forms of the Old Testament Literature")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("HDR – Harvard Dissertations in Religion")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("HSM – Harvard Semitic Monographs")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("IBC – Interpretation: A Bible Commentary for Teaching and Preaching")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ICC – International Critical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Int – Interpretation ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ITC – International Theological Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL – Journal of Biblical Literature ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("JSOTSup – Journal for the Study of the Old Testament Supplement Series")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("LNTS – The Library of New Testament Studies")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NAC – New American Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NCBC – New Century Bible Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NIDOTTE – New International Dictionary of Old Testament Theology and Exegesis")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("ed. Willem A. VanGemeren, 5 vols. (Grand Rapids: Zondervan; Carlisle: Paternoster, 1997)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NIVAC – "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("niv")]), _vm._v(" Application Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("OTL – Old Testament Library")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TDOT – Theological Dictionary of the Old Testament")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("ed. G. Johannes Botterweck and Helmer Ringgren, trans. John T. Willis et al., 8 vols. (Grand Rapids: Eerdmans, 1974–2006)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Them – Themelios ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("TOTC – Tyndale Old Testament Commentaries"), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("WBC – Word Biblical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("WTJ – Westminster Theological Journal ")])]), _vm._v(" "), _c('h3', {
    staticClass: "b_head",
    attrs: {
      "id": "sigil_toc_id_1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Dan_contents"
    }
  }, [_vm._v("Bible versions")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("esv")]), _vm._v(" – English Standard Version")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("lxx")]), _vm._v(" – Septuagint (pre-Christian Greek version of the Old Testament)")]), _vm._v(" "), _c('p', {
    staticClass: "fo_rleft"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30418d60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Dan_Abbrev.vue
// module id = 72
// module chunks = 0